import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
import styled from 'styled-components';
import { colors } from '@/theme/colors';
const FormContext = createContext(null);
export const useForm = () => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error('useForm must be used within a Form component');
    }
    return context;
};
export const Form = ({ children, onSubmit, className = '', layout = 'vertical', }) => {
    const [values, setValues] = useState({});
    const setFieldValue = (name, value) => {
        setValues(prev => ({ ...prev, [name]: value }));
    };
    const getFieldValue = (name) => {
        return values[name];
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
            onSubmit(values);
        }
    };
    const layoutClass = `legarta-form--${layout}`;
    return (_jsx(FormContext.Provider, { value: { values, setFieldValue, getFieldValue }, children: _jsx(StyledForm, { onSubmit: handleSubmit, className: `legarta-form ${layoutClass} ${className}`, children: children }) }));
};
export const FormItem = ({ name, label, required, children, className = '', }) => {
    const context = useContext(FormContext);
    const handleChange = (e) => {
        if (context && name) {
            context.setFieldValue(name, e.target.value);
        }
    };
    const clonedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child) && name) {
            return React.cloneElement(child, {
                onChange: handleChange,
                value: context?.getFieldValue(name) || '',
            });
        }
        return child;
    });
    return (_jsxs(StyledFormItem, { className: `legarta-form-item ${className}`, children: [label && (_jsx(FormLabel, { required: required, children: label })), clonedChildren] }));
};
const StyledForm = styled.form `
  &.legarta-form--vertical {
    .legarta-form-item {
      margin-bottom: 24px;
    }
  }

  &.legarta-form--horizontal {
    .legarta-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .legarta-form-label {
        width: 120px;
        margin-right: 16px;
        text-align: right;
      }
    }
  }
`;
const StyledFormItem = styled.div `
  margin-bottom: 24px;
`;
const FormLabel = styled.label `
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: ${colors.textPrimary};
  font-size: 14px;

  ${({ required }) => required && `
    &::after {
      content: ' *';
      color: ${colors.error};
    }
  `}
`;
